import Head from "next/head"

const PageHead = (props) => {
    const {
        title = false,
        description = false,
        keywords = false,
        link = false
    } = props;

    return (
        <Head>
            {title && <title>{title}</title>}
            {description && (
                <meta
                    name="description"
                    content={description}
                />
            )}
            {keywords && <meta name="keywords" content={keywords} />}
            {link &&  <link rel="canonical" href={link} />}
        </Head>
    )
}

export default PageHead